<template>
  <div class="error-expire">
    <div class="error-container">
      <div class="error-image">
        <img src="@/assets/images/error/expire.png" alt="">
      </div>
      <div class="error-tips">
        <div style="margin-bottom: 15px;">
          您的系统已到期，请联系您的销售经理！
          <div style="padding-top: 15px;"><span class="wl-btn" @click="relogin">重新登录</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'error-expire',
    data() {
      return {}
    },
    mounted() {

    },
    methods: {
      relogin() {
        this.$nextTick(() => {
          this.$router.push({
            path: '/login'
          })
        })
      },
    }
  }
</script>

<style lang="scss">
  .error-expire {
    height: 100%;
    width: 100%;
    position: relative;

    .error-container {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;

      .error-tips {
        padding-top: 10px;

        a {
          color: $mainColor;
        }
      }
    }
  }
</style>
